import { useInfiniteQuery } from '@tanstack/react-query';
import { getVisitHistory } from '../requests';
import type { VisitHistoryParams, VisitHistoryResponse } from '../../model';

interface Params {
  params?: VisitHistoryParams;
  enabled?: boolean;
}

export function useVisitHistoryInfinity({
  params,
  enabled = true,
}: Params = {}) {
  const queryKey = ['profile', 'visit-history', params];

  const query = useInfiniteQuery({
    queryKey,
    queryFn: ({ pageParam }) =>
      getVisitHistory({
        ...params,
        nextFrameId: pageParam ?? params?.nextFrameId,
      }),
    initialPageParam: params?.nextFrameId ?? undefined,
    getNextPageParam: lastPage => lastPage.nextFrameId ?? undefined,
    staleTime: 0,
    gcTime: 0,
    enabled,
  });

  const allItems =
    query.data?.pages.flatMap(
      (page: VisitHistoryResponse) => page.activities
    ) ?? [];

  return {
    ...query,
    items: allItems,
    hasNextPage: query.hasNextPage,
    fetchNextPage: query.fetchNextPage,
    isFetchingNextPage: query.isFetchingNextPage,
  };
}
